/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SavingInputs */

const en_saving = /** @type {(inputs: SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const he_saving = /** @type {(inputs: SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שומר...`)
};

/**
* | output |
* | --- |
* | "Saving..." |
*
* @param {SavingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const saving = /** @type {((inputs?: SavingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SavingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_saving(inputs)
	return he_saving(inputs)
});